import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import { CONTENT_TYPE_TO_URL } from "config/constants/editor";
import DashboardByline from "dashboard/components/DashboardByline";
import DashboardDate from "dashboard/components/DashboardDate";
import DashboardHeadline from "dashboard/components/DashboardHeadline";
import DashboardLock from "dashboard/components/DashboardLock";
import StatusIcon from "dashboard/components/StatusIcon";
import getEditorURL from "editor/utils/getEditorURL";
import DashboardSection from "dashboard/components/DashboardSection";

import styles from "./DashboardStoryLarge.css";

export default function DashboardStoryLarge(props) {
  const story = props.story;
  const contentType =
    CONTENT_TYPE_TO_URL[story.content_type] || story.editorType;

  return (
    <Link
      to={getEditorURL(contentType, story.id, true)}
      className={styles.root}
      data-cy="dashboardStoryLink"
    >
      <div className={styles.statusContainer}>
        <StatusIcon status={story.status} />
      </div>

      <div className={styles.headlineContainer}>
        <DashboardHeadline
          headline={story.headline}
          id={story.id}
          isPrivate={story.isPrivate}
          type={story.content_type}
        />
        <DashboardDate
          last_updated={story.last_updated}
          scheduled_date={story.scheduled_date}
          published_date={story.published_date}
          eta={story.eta}
          status={story.status}
          in_edits={story.in_edits}
          showPublishedDatetime={props.showPublishedDatetime}
          lock={story.lock}
        />
      </div>

      {story.authors && (
        <div className={styles.bylineContainer}>
          <DashboardByline authors={story.authors} editors={story.editors} />
        </div>
      )}

      <div className={styles.sectionContainer}>
        <DashboardSection {...story} />
      </div>

      <DashboardLock lock={story.lock} className={styles.lock} />
    </Link>
  );
}

DashboardStoryLarge.propTypes = {
  story: PropTypes.object.isRequired,
  showPublishedDatetime: PropTypes.func.isRequired,
};
